class GeotabSyncRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "GeotabSync";

    super(entityName);

    App.Forms.GeotabSyncConfiguration = App.Forms.GeotabSyncConfiguration || {};
    App.Forms.GeotabSyncConfiguration.layout =
      App.Forms.GeotabSyncConfiguration.layout || {};
    Monet.Session.Security.permissions.push({
      key: "GEOTAB_SYNC",
      authority: "GEOTAB_SYNC"
    });
  }

  renderInlineMessage = (resourceKey, type) => {
    const monetMessage = new Monet.Form.Messages.InlineMessage();
    const resourceMessage =  Monet.I18n.getResourcesByKey(resourceKey);
    const errorMessages = [];
    errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(resourceMessage))

    monetMessage.setScope("#GeotabSyncConfiguration .GeotabSyncConfiguration");
    monetMessage.setInfoType(type);
    monetMessage.setMessage({ errorMessages });
    monetMessage.triggerMessage();
  }

  renderSyncForm = entity => {
    const layout = App.Forms[entity].layout.edit;
    const router = App.Objects.GeotabSync;
    const fieldDependencies = {
      "equipmentConfiguration.sync": [
        "equipmentConfiguration.organization",
        "equipmentConfiguration.equipmentType",
        "equipmentConfiguration.equipmentMatchKeyType"
      ],
      "driverConfiguration.sync": [
        "driverConfiguration.organization",
        "driverConfiguration.driverMatchKeyType"
      ],
      "locationConfiguration.sync": ["locationConfiguration.organization"]
    };

    const enableField = field => {
      field.enable();
      field.setMandatory(true);
      if (field.postRender) {
        field.postRender();
      }
    };

    const disableField = field => {
      field.clear();
      field.disable();
      field.setMandatory(false);
      if (field.postRender) {
        field.postRender();
      }
    };

    const enableFields = fields => fields.forEach(field => enableField(field));

    const disableFields = fields =>
      fields.forEach(field => disableField(field));

    const toggleFieldStatus = event => {
      const dependentFields = (
        fieldDependencies[event.target.name] || []
      ).reduce((acc, curr) => {
        const field = App.Forms.GeotabSyncConfiguration.form.fields[curr];
        if (field) {
          acc.push(field);
        }
        return acc;
      }, []);
      if (!event.target.checked) {
        disableFields(dependentFields);
      } else {
        enableFields(dependentFields);
      }
    };

    const initializeFields = () => {
      Object.keys(fieldDependencies).forEach(key => {
        const parentField = App.Forms.GeotabSyncConfiguration.form.fields[key];
        const dependentFields = fieldDependencies[key].reduce((acc, curr) => {
          const field = App.Forms.GeotabSyncConfiguration.form.fields[curr];
          if (field) {
            acc.push(field);
          }
          return acc;
        }, []);
        if (parentField.input.checked) {
          enableFields(dependentFields);
        } else {
          disableFields(dependentFields);
        }
      });
    };

    const addEventListeners = () => {
      Object.keys(fieldDependencies).forEach(key => {
        const field = App.Forms.GeotabSyncConfiguration.form.fields[key];
        field.addClickEventListener(toggleFieldStatus);
      });
      App.Forms.GeotabSyncConfiguration.form.fields[
        "hosConfiguration.viewLog"
      ].addEventClickListener(() => {
        window.location = "#/HOSGeoTabSyncLog";
      });
    };

    const createForm = () => {
      Monet.Form.checkFormTemplate(entity);
      router.generateDatamapper(entity, layout);
      router.renderMonetForm(entity, layout, entity);
    };

    const getDataAndSetFormValues = () => {
      const ajax = new Monet.Ajax();
      ajax.url = "GeotabSyncConfiguration/CurrentlyActive";
      ajax.method = "GET";

      const success = data => {
        if (data) {
          const dataObjects = Object.keys(data);
          dataObjects.forEach(key => {
            const children = Object.keys(data[key]);
            children.forEach(childkey => {
              if (childkey !== "id") {
                const fieldKey = `${key}.${childkey}`;
                App.Forms.GeotabSyncConfiguration.form.setFieldValue(
                  fieldKey,
                  data[key][childkey]
                );
              }
            });
          });
        }
        addEventListeners();
        initializeFields();
      };

      const error = () => {
        this.renderInlineMessage("general.exception.service.unavailable", "error");
      }
      
      ajax.success = success;
      ajax.error = error;
      
      ajax.send();
    };
    createForm();
    getDataAndSetFormValues();
  };

  update = () => {
    const form = App.Forms.GeotabSyncConfiguration.form;
    const values = form.getValues();
    const data = {
      hosConfiguration: {
        sync: values["hosConfiguration.sync"]
      },
      equipmentConfiguration: {
        organization: values["equipmentConfiguration.organization"],
        equipmentType: values["equipmentConfiguration.equipmentType"],
        equipmentMatchKeyType:
          values["equipmentConfiguration.equipmentMatchKeyType"],
        sync: values["equipmentConfiguration.sync"]
      },
      driverConfiguration: {
        sync: values["driverConfiguration.sync"],
        organization: values["driverConfiguration.organization"],
        driverMatchKeyType: values["driverConfiguration.driverMatchKeyType"]
      },
      locationConfiguration: {
        sync: values["locationConfiguration.sync"],
        organization: values["locationConfiguration.organization"]
      }
    };

    if (!form.validate().status) {
      return;
    }

    form.triggerLoadingBtns();

    const ajax = new Monet.Ajax();
    ajax.url = "GeotabSyncConfiguration";
    ajax.method = "POST";
    ajax.data = data;
    ajax.success = () => {
      this.renderInlineMessage("geotabsyncconfiguration.saved", "success");
    };
    ajax.error = responseText => {
      this.renderInlineMessage("general.exception.service.unavailable", "error");
      App.Objects.GeotabSync.showErrorExceptionOnPopupForm(responseText);
    }
    ajax.send();

    setTimeout(() => {
      form.triggerLoadingBtns();
    }, 1500);
  };

  showConfigForm = () => {
    const entity = "GeotabSyncConfiguration";
    const pageLayout = new Monet.PageLayout();

    if (!App.Forms.GeotabSyncConfiguration.layout.edit) {
      pageLayout.getLayout(entity, "edit", () =>
        App.Objects.GeotabSync.renderSyncForm(entity)
      );
    } else {
      App.Objects.GeotabSync.renderSyncForm(entity);
    }
  };
}

App.Routers.GeotabSync = GeotabSyncRouter;
